import { useQuery } from '@tanstack/react-query';
import {
  districtListQueryOptions,
  divisionListQueryOptions,
  thanaListQueryOptions,
} from '@/features/geo/api/geo.api';

interface UseGeoCascadeInput {
  divisionId: number | undefined;
  districtId: number | undefined;
}

export function useGeoCascade({ divisionId, districtId }: UseGeoCascadeInput) {
  const { data: divisions, isLoading: divisionsLoading } = useQuery(divisionListQueryOptions());
  const { data: districts, isLoading: districtsLoading } = useQuery({
    ...districtListQueryOptions(divisionId ?? 0),
    enabled: divisionId !== undefined,
  });
  const { data: thanas, isLoading: thanasLoading } = useQuery({
    ...thanaListQueryOptions(districtId ?? 0),
    enabled: districtId !== undefined,
  });

  return {
    divisions,
    divisionsLoading,
    districts,
    districtsLoading,
    districtDisabled: divisionId === undefined,
    thanas,
    thanasLoading,
    thanaDisabled: districtId === undefined,
  };
}
